import type { ChecklistShareResult } from '../api/checklistsApi';

/**
 * Monta a mensagem de WhatsApp do compartilhamento do checklist (at-126).
 *
 * O backend nunca monta URL de frontend (a env de origens é uma LISTA — at-70); por isso os
 * links nascem aqui, a partir da origem da própria tela.
 *
 * `{{acompanhamento}}` é o link do acompanhamento do associado, que contém o checklist dentro.
 * Sem o token (backend anterior à at-126, ou falha ao criá-lo), o marcador recebe o link do
 * checklist: a mensagem nunca sai sem link nenhum.
 */
export function montarMensagemDoShare(share: ChecklistShareResult, origem: string = window.location.origin): string {
  const linkChecklist = `${origem}/checklist/${share.token}`;
  const linkAcompanhamento = share.acompanhamento?.token ? `${origem}/acompanhamento/${share.acompanhamento.token}` : '';

  return share.template
    .replace(/\{\{acompanhamento\}\}/g, linkAcompanhamento || linkChecklist)
    .replace(/\{\{link\}\}/g, linkChecklist)
    .replace(/\{\{placa\}\}/g, share.plate || '')
    .replace(/\{\{nome\}\}/g, share.ownerName || 'cliente');
}
